export enum Path {
  HOME = "/",
  OPERATIONAL_ENTITY_SEARCH = "/search",
  CLIENT_HIERARCHY_SEARCH = "/client-hierarchy-search",
  CREATE_OPERATIONAL_ENTITY = "/create-operational-entity",
  OPERATIONAL_ENTITY = "/entity",
  CLIENT_HIERARCHY = "/client-hierarchy"
}
